import React from 'react';
import { Link } from 'react-router-dom';
import './IvsEvs.css';

const IvsEvs = () => {
  return (
    <div className="ivs-evs">
      <div className="ivs-evs__header">
        <h1>IVs and EVs Guide</h1>
      </div>
      
      <div className="ivs-evs__content">
        <section className="ivs-evs__section">
          <h2>Individual Values (IVs)</h2>
          <p>
            Individual Values (IVs) are hidden values that determine a Pokémon's base stats.
            Each stat (HP, Attack, Defense, Special Attack, Special Defense, and Speed) has an IV
            ranging from 0 to 31, with 31 being the best.
          </p>
          <div className="ivs-evs__info-box">
            <h3>Key Points about IVs:</h3>
            <ul>
              <li>IVs are determined when a Pokémon is generated (caught, hatched, or received)</li>
              <li>Each stat can have an IV between 0-31</li>
              <li>IVs cannot be changed through normal gameplay (except with Hyper Training)</li>
              <li>Higher IVs result in better stats</li>
            </ul>
          </div>
          <div className="ivs-evs__items-section">
            <h3>How to Maximize IVs</h3>
            <p>You can use the following items to improve your Pokémon's IVs through Hyper Training:</p>
            <div className="ivs-evs__items-grid">
              <Link to="/items/Bottle%20Cap" className="ivs-evs__item-card">
                <h4>Bottle Cap</h4>
                <p>Maximizes one IV stat to 31 through Hyper Training</p>
              </Link>
              <Link to="/items/Gold%20Bottle%20Cap" className="ivs-evs__item-card">
                <h4>Gold Bottle Cap</h4>
                <p>Maximizes all IV stats to 31 through Hyper Training</p>
              </Link>
            </div>
          </div>
        </section>

        <section className="ivs-evs__section">
          <h2>Effort Values (EVs)</h2>
          <p>
            Effort Values (EVs) are points that increase a Pokémon's stats based on the Pokémon it defeats.
            Each Pokémon can have a maximum of 510 total EVs, with no more than 252 EVs in any single stat.
          </p>
          <div className="ivs-evs__info-box">
            <h3>Key Points about EVs:</h3>
            <ul>
              <li>EVs are gained through battling or using items</li>
              <li>Maximum 252 EVs per stat</li>
              <li>Total maximum of 510 EVs across all stats</li>
              <li>Every 4 EVs equals +1 to the corresponding stat at level 100</li>
            </ul>
          </div>
          <div className="ivs-evs__items-section">
            <h3>Vitamins for EV Training</h3>
            <p>You can use these vitamins to quickly increase specific EVs:</p>
            <div className="ivs-evs__items-grid">
              <Link to="/items/HP%20Up" className="ivs-evs__item-card">
                <h4>HP Up</h4>
                <p>Increases HP EVs</p>
              </Link>
              <Link to="/items/Protein" className="ivs-evs__item-card">
                <h4>Protein</h4>
                <p>Increases Attack EVs</p>
              </Link>
              <Link to="/items/Iron" className="ivs-evs__item-card">
                <h4>Iron</h4>
                <p>Increases Defense EVs</p>
              </Link>
              <Link to="/items/Calcium" className="ivs-evs__item-card">
                <h4>Calcium</h4>
                <p>Increases Special Attack EVs</p>
              </Link>
              <Link to="/items/Zinc" className="ivs-evs__item-card">
                <h4>Zinc</h4>
                <p>Increases Special Defense EVs</p>
              </Link>
              <Link to="/items/Carbos" className="ivs-evs__item-card">
                <h4>Carbos</h4>
                <p>Increases Speed EVs</p>
              </Link>
            </div>
            <div className="ivs-evs__items-note">
              <p>Note: Each vitamin increases the corresponding EV stat by 10 points. You can use up to 26 of the same vitamin on a single Pokémon.</p>
            </div>
          </div>
        </section>

        <section className="ivs-evs__section">
          <h2>Competitive Importance</h2>
          <p>
            Understanding IVs and EVs is crucial for competitive Pokémon battling. They allow you to:
          </p>
          <ul className="ivs-evs__benefits">
            <li>Maximize your Pokémon's potential in specific stats</li>
            <li>Create specialized builds for different strategies</li>
            <li>Optimize speed tiers and survivability</li>
            <li>Gain an edge in competitive battles</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default IvsEvs; 